module.exports = __webpack_public_path__ + "static/img/iso9001.fe0aac3b.jpg";